import { queryStringToRecord } from '@/utils/query-string';

/**
 * Translates a complex key string based on specific formatting rules.
 * If the key starts with '||', returns the string after these characters.
 * If the key contains '|', splits it into a key and query string, then translates with parameters.
 * Otherwise, translates the key directly.
 *
 * @param key - The key string to translate. Can be null or contain special formatting.
 * @param t - Translation function that accepts a key and optional parameters.
 * @returns The translated string or empty string if key is null.
 */
export function translateComplexKey(
  key: Nullable<string>,
  t: (key: string, params?: Record<string, unknown>) => string,
): string {
  if (!key) return '';
  if (key.startsWith('||')) {
    return key.slice(2);
  }
  if (key.includes('|')) {
    const [k = '', qs = ''] = key.split('|');

    if (qs.includes('[')) {
      const literal = qs.slice(1, -1);

      return t(k) + literal;
    }

    const params = queryStringToRecord(qs);
    return t(k, params);
  }
  return t(key);
}
